import { useStore } from 'react-redux'
import { getIsQAEnabled } from 'selectors/shared/qa'

const { NODE_ENV } = process.env // APP_ENV
const isTest = NODE_ENV === 'test' // || APP_ENV === 'local'

type QAHook = {
  testId: (value: string) => Record<string, any>
}
// Hook
const useQA = (): QAHook => {
  const store = useStore()
  const isEnabled = getIsQAEnabled(store.getState())

  const testId = (value: string): Record<string, any> => {
    return isEnabled || isTest ? { 'data-testid': value } : {}
  }

  return { testId }
}

export default useQA
